<template>
  <div>
    <v-btn class="rounded-pill" color="primary" @click="setHelp = true"><v-icon>mdi-help-circle-outline</v-icon></v-btn>
    <v-dialog v-model="setHelp" max-width="70%" transition="dialog-transition">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title><v-icon>mdi-help-circle-outline</v-icon> Help</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-list>
          <v-list-group
            v-for="item in items"
            :key="item.title"
            v-model="item.active"
            :prepend-icon="item.action"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item v-for="child in item.items" :key="child.title">
              <v-icon>{{ child.icon }}</v-icon>
              <v-list-item-content>
                <v-list-item-title class="pa-3" v-text="child.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      setHelp: false,
      items: [
        {
          action: 'mdi-mouse-move-vertical',
          items: [{ title: ' - ใช้เมาส์เพื่อเลื่อนดูสไลด์หรือเฟรมต่างๆ โดยเลื่อนลูกกลิ้งเมาส์ขึ้นลงเพื่อเปลี่ยนสไลด์' }
          ],
          title: 'Scroll'
        },
        {
          action: 'mdi-magnify',
          items: [{ title: ' - ใช้เมาส์เพื่อซูมดูภาพ โดยการเลื่อนลูกกลิ้งเมาส์ขึ้นเพื่อซูมเข้า และเลื่อนลูกกลิ้งเมาส์ลงเพื่อลดขนาดภาพ' }],
          title: 'ZoomAndPan'
        },
        {
          action: 'mdi-contrast-circle',
          items: [{ title: 'เมาส์ลากขึ้นลงที่ภาพ เพื่อปรับแสง' }],
          title: 'Window/Level'
        },
        {
          action: 'mdi-autorenew',
          items: [{ title: 'คลิกที่ tool หรือ คลิกที่ Icon เพื่อเปลื่ยนมุมมอง' }],
          title: 'Side'
        },
        {
          action: 'mdi-undo-variant',
          items: [{ title: 'รีเซตค่าทุกอย่างให้เป็นค่าเริ่มต้น' }],
          title: 'Reset'
        },
        {
          action: 'mdi-draw',
          items: [
            { icon: 'mdi-shape-rectangle-plus', title: 'ใช้ตีกรอบสี่เหลี่ยม' },
            { icon: 'mdi-pencil-ruler-outline', title: 'ใช้ตีกรอบแบบไม้บรรทัด' },
            { icon: 'mdi-ellipse-outline', title: 'ใช้ตีกรอบวงรี' },
            { icon: 'mdi-circle-outline', title: 'ใช้ตีกรอบวงกลม' },
            { icon: 'mdi-arrow-top-right-thin', title: 'ใช้ตีกรอบหัวศร' },
            { icon: 'mdi-angle-acute', title: 'ใช้ตีกรอบแบบองศา' },
            { icon: 'mdi-dots-circle', title: 'ใช้ตีกรอบอิสระ แบบมุม' },
            { icon: 'mdi-draw', title: 'ใช้ตีกรอบแบบอิสระ' }],
          title: 'Draw'
        },
        {
          action: 'mdi-eye',
          items: [{ title: 'เปิด-ปิด text ในภาพ' }],
          title: 'eye'
        },
        {
          action: 'mdi-information-outline',
          items: [{ title: 'แสดงข้อมูล file รายละเอียอดของภาพ' }],
          title: 'Infomation'
        }

      ]
    }
  },
  methods: {
    closeDialog () {
      this.setHelp = false
    }
  }
}
</script>
